import { RootState } from '@vision/ui/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectReportDetailSelector = (state: RootState) => state.ReportsDetailState.reportDetail;

export const reportsDetailMainDateRangeSelector = (state: RootState) => state.ReportsDetailState.selectedDate;

export const reportsDetailMainChangedToDateRangeSelector = (state: RootState) =>
  state.ReportsDetailState.changedToDateRange;

export const reportsDetailSelectedMainFiltersSelector = (state: RootState) =>
  state.ReportsDetailState.selectedMainFilters;

export const reportsDetailLockedMainFiltersSelector = (state: RootState) => state.ReportsDetailState.lockedMainFilters;

export const reportsDetailWidgetsSelector = (state: RootState) => state.ReportsDetailState.widgets;

export const reportsDetailActiveResizingWidgetIdSelector = (state: RootState) =>
  state.ReportsDetailState.activeResizingWidgetId;

export const reportsDetailWidgetLoadStatusSelector = (state: RootState) => state.ReportsDetailState.widgetLoadStatus;

export const reportsDetailAreAllWidgetsLoadedSelector = createSelector(
  [reportsDetailWidgetLoadStatusSelector],
  (widgetLoadStatus) => {
    const statuses = Object.values(widgetLoadStatus);

    return statuses.length > 0 && statuses.every(Boolean);
  },
);

export const reportsDetailIsExportingSelector = (state: RootState) => state.ReportsDetailState.isExporting;

export const reportsDetailJobResultsSelector = (state: RootState) => state.ReportsDetailState.jobResults;

export const reportsDetailHeaderSettingsSelector = (state: RootState) => state.ReportsDetailState.headerSettings;

export const reportsDetailLogoActiveSelector = (state: RootState) => state.ReportsDetailState.headerSettings.logoActive;

export const reportsDetailTitleActiveSelector = (state: RootState) =>
  state.ReportsDetailState.headerSettings.titleActive;

export const reportsDetailDescriptionActiveSelector = (state: RootState) =>
  state.ReportsDetailState.headerSettings.descriptionActive;
